import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { SINGLE_EMPLOYEE_QUERY } from "../../graphql/Employees/Employees.graphql";

function Employee({ RecId, ...props }) {
  const payload = useQuery(SINGLE_EMPLOYEE_QUERY, {
    variables: { where: { RecId } }
  });

  return props.children(payload);
}

Employee.propTypes = {
  RecId: PropTypes.number,
  children: PropTypes.func
};

export default Employee;
